import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CalendarUnvailabilities from '../../components/CalendarUnvailabilities';
import McSwitch from '../../components/McSwitch';

import { useAxios } from '../../utils/hook/useAxios';

function Unaivalabities() {
  const params = useParams();

  const { voitureId, mois } = params;
  const [PriceValue, setPriceValue] = useState(0);
  const [UnavailabilityDateStart, setUnavailabilityDateStart] = useState('');
  const [UnavailabilityDateEnd, setUnavailabilityDateEnd] = useState('');
  const [Unavailabilities, setUnavailabilities] = useState([]);

  const [CurrentDateFixed, setCurrentDateFixed] = useState(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  });

  const [selectedValue, setSelectedValue] = useState('');
  const [selectedValue2, setSelectedValue2] = useState('');
  const [WeekDay, setWeekDay] = useState('0');
  const axios = useAxios();
  const generateHourOptions = () => {
    const options = [];

    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const hourString = hour.toString().padStart(2, '0'); // Ajouter un zéro en tête si nécessaire
        const minuteString = minute.toString().padStart(2, '0'); // Ajouter un zéro en tête si nécessaire
        const timeString = `${hourString}:${minuteString}`;
        options.push(
          <option key={timeString} value={timeString}>
            {timeString}
          </option>
        );
      }
    }

    return options;
  };
  const [isChecked, setIsChecked] = useState(true); // Initialisez l'état de la case cochée

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked); // Mettez à jour l'état de la case cochée lorsqu'elle est cochée ou décochée
  };

  // Fonction pour gérer le changement de sélection
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    console.log(event.target.value);
  };
  const handleChange2 = (event) => {
    setSelectedValue2(event.target.value);
    console.log(event.target.value);
  };
  const getDayOfWeek = (date) => {
    const day = date.getDay();
    return day === 0 ? 6 : day - 1;
  };
  function handleDefinirIndisponibilite() {
    let fetchReviews = async () => {
      try {
        const response = await axios.post('/unavailabilities/', {
          vehiculeId: Number(voitureId),
          start_date: UnavailabilityDateStart,
          end_date: UnavailabilityDateEnd,
          start_time: selectedValue,
          end_time: selectedValue2,
          type: isChecked ? '0' : '1',
          WeekDAY: getDayOfWeek(new Date(UnavailabilityDateStart)),
        });

        if (response.data) {
          toast.success('Indisponibilité ajoutée pour votre véhicule');

          const res = await axios.get(
            '/unavailabilities/getbyvehiculeid-date/' + voitureId + '?date=' + CurrentDateFixed
          );
          if (res.data) {
            setUnavailabilities(res.data);
          }
          window.location.href = '/account/voitures';
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }

  return (
    <main className="mc-home mc-form-page">
      <div className="mc-form-shell mc-form-shell--wide">
        <div className="mc-stepper">
          <div className="mc-stepper-top">
            <span>Inscrire ma voiture</span>
            <span>Dernière étape</span>
          </div>
          <div
            className="mc-stepper-bar"
            role="progressbar"
            aria-label="Progression de l'inscription"
            aria-valuenow="99"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div className="mc-stepper-fill" style={{ width: '99%' }}></div>
          </div>
        </div>

        <div className="mc-avail-layout">
          {/* ---------- Calendrier ---------- */}
          <section className="mc-form-card">
            <span className="mc-section-kicker">CALENDRIER</span>
            <CalendarUnvailabilities
              mois={parseInt(mois)}
              vehiculeId={parseInt(voitureId)}
            ></CalendarUnvailabilities>
          </section>

          {/* ---------- Indisponibilités ---------- */}
          <aside className="mc-form-card">
            <h2 className="mc-form-section-title">Indisponibilités</h2>
            <p className="mc-form-subtitle">
              Définissez l'indisponibilité de votre voiture pour bloquer les réservations pendant
              ces périodes.
            </p>

            <details className="mc-collapse">
              <summary className="mc-btn mc-btn--secondary mc-btn--block">
                <ion-icon name="add-outline"></ion-icon>
                Ajouter une période
              </summary>

              <div className="mc-collapse-body">
                <h3 className="mc-form-section-title">Ajouter une indisponibilité</h3>
                <p className="mc-field-hint">
                  Bloquez les périodes où votre voiture n'est pas disponible. Plus votre voiture est
                  disponible, plus vous recevrez de demandes de voyage, surtout les week-ends et les
                  jours fériés.
                </p>

                <div className="mc-field">
                  <label className="mc-field-label" htmlFor="unavDateStart">
                    Début
                  </label>
                  <div className="mc-datetime-row">
                    <input
                      type="date"
                      className="mc-input"
                      id="unavDateStart"
                      value={UnavailabilityDateStart}
                      onChange={(e) => setUnavailabilityDateStart(e.target.value)}
                    />
                    <select
                      className="mc-select"
                      aria-label="Heure de début"
                      value={selectedValue}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Heure
                      </option>
                      {generateHourOptions()}
                    </select>
                  </div>
                </div>

                <div className="mc-field">
                  <label className="mc-field-label" htmlFor="unavDateEnd">
                    Fin
                  </label>
                  <div className="mc-datetime-row">
                    <input
                      type="date"
                      className="mc-input"
                      id="unavDateEnd"
                      value={UnavailabilityDateEnd}
                      onChange={(e) => setUnavailabilityDateEnd(e.target.value)}
                    />
                    <select
                      className="mc-select"
                      aria-label="Heure de fin"
                      value={selectedValue2}
                      onChange={handleChange2}
                    >
                      <option value="" disabled>
                        Heure
                      </option>
                      {generateHourOptions()}
                    </select>
                  </div>
                </div>

                {/* <div className="mb-3">
                  <label htmlFor="Jour de de la semaine">Jour</label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    value={WeekDay}
                    onChange={(e) => setWeekDay(e.target.value)}
                  >
                    <option value="0">Lundi</option>
                    <option value="1">Mardi</option>
                    <option value="2">Mercredi</option>
                    <option value="3">Jeudi</option>
                    <option value="4">Vendredi</option>
                    <option value="4">Samedi</option>
                    <option value="4">Dimanche</option>
                  </select>
                </div> */}

                <div className="mc-field">
                  <McSwitch
                    id="flexCheckChecked"
                    label="Répéter chaque semaine"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                </div>

                <button
                  type="button"
                  className="mc-btn mc-btn--primary mc-btn--block mc-collapse-submit"
                  onClick={handleDefinirIndisponibilite}
                >
                  Définir l'indisponibilité
                </button>
              </div>
            </details>

            <a href="/account/voitures" className="mc-btn mc-btn--ghost mc-btn--block mc-side-link">
              Aller dans le compte hôte
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </a>

            <div className="mc-form-block">
              <h3 className="mc-form-section-title mc-block-title">
                <ion-icon name="ban-outline"></ion-icon>
                Indisponibilités du véhicule
              </h3>

              {Unavailabilities && Unavailabilities.length > 0 ? (
                <ul className="mc-unavail-list">
                  {Unavailabilities.map((una, index) => (
                    <li className="mc-unavail-item" key={una.id ?? index}>
                      <div className="mc-unavail-line">
                        <span>Du {una.start_date}</span>
                        <em className="mc-time-badge">{una.start_time}</em>
                      </div>
                      <div className="mc-unavail-line">
                        <span>Au {una.end_date}</span>
                        <em className="mc-time-badge">{una.end_time}</em>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="mc-field-hint">Aucune indisponibilité pour le moment.</p>
              )}
            </div>
          </aside>
        </div>
      </div>
    </main>
  );
}

export default Unaivalabities;
